<template>
  <div class="bg-white mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="navigateToShoppingCart">keyboard_arrow_left</i>
            <span class="title-text" @click="navigateToShoppingCart">Checkout</span>
          </div>
        </div>
      </div>
      <!-- /banner -->
    </div>
    <div class="content-padding" />
    <form class="pb-100px" @submit.prevent="placeOrder">
      <div class="container mt-2">
        <div class="row">
          <div class="col-12">
            <div class="bg-white mb-2">
              <div class="d-flex justify-content-center">
                <div class="w-100">
                  <h4>Getting your giftcard</h4>
                  <my-detail
                    ref="myDetails"
                    v-if="!user"
                    :edit-model="detailModel"
                    @save-user="saveUser"
                    :for-gift="true"
                  />
                  <payment
                    ref="payment"
                    :user="user"
                    :dbuser="dbuser"
                    :edit-model="paymentModel"
                    @save-credit="saveCredit"
                  />

                  <div v-show="error" class="w-100 mt-s4">
                    <div class="alert alert-danger" role="alert">
                      <strong>{{ error }}</strong>
                    </div>
                  </div>

                  <footer class="full-extras-footer">
                    <button type="submit" class="btn btn-primary" :disabled="proccessing">
                      <span v-show="!proccessing" style="float:left;">Pay Now</span>
                      <span style="float:right;">
                        {{
                        giftCartValue | formatMoney
                        }}
                      </span>
                      <span v-show="proccessing">
                        <i class="spin ml-4" />
                      </span>
                    </button>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MyDetail from "../../shop/Checkout/partials/MyDetail";
import Payment from "../../shop/Checkout/partials/Payment";
import { getStore } from "../../../api/services/storeService.js";
import { getDBUser } from "../../../api/services/userService.js";
import shared from "../../../sharedscripts/shop/Checkout/giftCheckout.js";
import { logger } from "./../../../api/Logger.js";
export default {
  components: {
    MyDetail,
    Payment
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userIsExist: false,
      error: "",
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      isDelivery: true,
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      registerNew: false,
      saveCard: false,
      payByCard: false,
      store: {},
      dbuser: {},
      proccessing: false
    };
  },

  computed: {
    ...shared.computed
  },
  watch: {
    user() {
      let that = this;
      if (this.user) {
        getDBUser(this.user.id).onSnapshot(
          function(doc) {
            if (doc.exists) {
              that.dbuser = doc.data();
              that.initModel();
            }
          },
          function(reason) {
            logger.log(
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath,
              logger.LogType.Error
            );
            that.$router.replace("/GeneralError");
          }
        );
      }
    },
    holder() {
      this.paymentModel.CardHolder = this.holder;
    }
  },
  mounted() {
    let that = this;
    getStore(this.storeid)
      .get()
      .then(function(doc) {
        that.setStoreLoaded();
        if (doc.exists) {
          that.store = doc.data();
        }
      })
      .catch(reason => {
        logger.log(
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath,
          logger.LogType.Error
        );
        that.$router.replace("/GeneralError");
      });
    if (this.user) {
      getDBUser(this.user.id).onSnapshot(
        function(doc) {
          if (doc.exists) {
            that.dbuser = doc.data();
            that.initModel();
          }
        },
        function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath,
            logger.LogType.Error
          );
          that.$router.replace("/GeneralError");
        }
      );
    }
  },
  methods: {
    ...shared.methods,
    navigateToShoppingCart() {
      this.$router.push({
        name: "giftshoppingcartmobile",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename
        }
      });
    }
  }
};
</script>
